export default __webpack_public_path__ + "i18n/translations/translation-bn.e880f5f8.json";